var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.step == 1)?_c('tab1',{attrs:{"dataId":_vm.dataId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }